module.exports = __webpack_public_path__ + "static/media/team.db4852b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/dashboard-icons/team.svg
// module id = 2121
// module chunks = 0